import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../services/apiService";

export const fetchReadyforDelivery = createAsyncThunk(
  "readyforDelievry/fetchReadyforDelivery",
  async (_, { rejectWithValue }) => {
    try {
        const token = localStorage.getItem("token");
      const response = await apiService.get('/laundry/items-delivery', {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const readyforDelivery = createSlice({
  name: "readyforDelievry",
  initialState: {
    readyforDeliverys: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReadyforDelivery.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchReadyforDelivery.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.readyforDeliverys = action.payload.data;
      })
      .addCase(fetchReadyforDelivery.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default readyforDelivery.reducer;
